<footer class="bg-gray-900 text-white mt-8 sm:mt-12 md:mt-16">
  <div class="max-w-7xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
    <div class="grid grid-cols-2 md:grid-cols-4 gap-6 sm:gap-8">
      <div>
        <div class="mb-4">
          <img
            src="https://zoomeduca.com.br/logo.svg"
            alt="Zoom Educa"
            class="h-8 brightness-0 invert"
          />
        </div>
        <p class="text-gray-400 text-sm">
          Excelência na automatização de processos seletivos e concursos públicos.
        </p>
      </div>
      <div>
        <h4 class="font-semibold mb-3">Sobre</h4>
        <ul class="space-y-2 text-sm text-gray-400">
          <li>
            <a href="https://zoomeduca.com.br" class="hover:text-white transition-colors"
              >Quem Somos</a
            >
          </li>
        </ul>
      </div>
      <div>
        <h4 class="font-semibold mb-3">Suporte</h4>
        <ul class="space-y-2 text-sm text-gray-400">
          <li>
            <a href="mailto:{{ emailSupport }}" class="hover:text-white transition-colors"
              >{{ emailSupport }}</a
            >
          </li>
          <li>
            <a href="tel:{{ phoneSupport }}" class="hover:text-white transition-colors"
              >{{ phoneSupport }}</a
            >
          </li>
        </ul>
      </div>
      <div>
        <h4 class="font-semibold mb-3">Legal</h4>
        <ul class="space-y-2 text-sm text-gray-400">
          <li>
            <a routerLink="/termos-de-uso" class="hover:text-white transition-colors"
              >Termos de Uso</a
            >
          </li>
          <li>
            <a routerLink="/politica-privacidade" class="hover:text-white transition-colors"
              >Política de Privacidade</a
            >
          </li>
          <li>
            <a routerLink="/lgpd" class="hover:text-white transition-colors">LGPD</a>
          </li>
        </ul>
      </div>
    </div>
    <div
      class="border-t border-gray-800 mt-8 pt-8 text-center text-sm text-gray-400"
    >
      <p>© {{ currentYear }} Zoom Educa. Todos os direitos reservados.</p>
    </div>
  </div>
</footer>
